export const checkRole = (authorizedRoles: any, userRole: string[]) => {
  if (authorizedRoles && userRole) {
    return authorizedRoles.some((role: string) => userRole.includes(role)) ? true : false
  } else return false
}
